import styles from './Style.module.css';
import PremiumIcon from '../../../Components/Icons/PremiumIcon';
import Loader from './Loader';
import { useLocation } from '../../../Context/Location/LocationContext';
import { setSessionStorageValue, STORAGE_KEYS } from '../../../Utils/SessionStorage';

export const OutletTypes = ({ outletTypeList, loading, onSelect }) => {
  const { outletTypeID, setOutletTypeID } = useLocation();

  const outletTypeClick = (value) => {
     onSelect?.(value);
    setOutletTypeID(value);
    setSessionStorageValue(STORAGE_KEYS.OUTLET_TYPE, value);
  };


  return (
    <div className={`${styles.outletTypeOptions} container-md`}>
      {loading ?
        <Loader />
      :
      outletTypeList?.length > 0 && (
        outletTypeList?.map((item, index) => (
          <button 
            key={item.id}
            type='button'
              className={`${styles.outletTypeBtn} ${String(item.id) === String(outletTypeID) ? styles.active : ""}`}
            onClick={() => outletTypeClick(item.id)}
            >
              {/* Premium Star Icon */}
            {/* {item?.id===1 && <PremiumIcon fill={item?.id===outletTypeID ? "var(--PrimaryColor800)" : "var(--Neutral600)"} />} */}
            {item.name}
          </button>
        ))
      )
      }
    </div>
  )
}







